module.exports = __webpack_public_path__ + "static/media/brand-6.9dd948d4.png";